import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { FundsResult } from '../entities';
import { AutoCompleteEnvironment } from '../environment';
export class AutocompleteFundRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(AutoCompleteEnvironment).fundsUrl, session);
  }

  /**
   * Takes input query makes restful request and returns list of funds containing that term
   *
   * @param query - input query
   * @returns - list of funds
   */
  public getAutoCompleteFunds = async (fund: string, limit = 10): SafePromise<FundsResult> => {
    const url = this.URL(`/api/v1/sec/autocomplete/funds`, { fund, limit });
    return this.get<FundsResult>(url, { credentials: 'same-origin' });
  };
}
